import type { EmailAuthCandidatesSnapshot } from "le-coffre-resources/dist/Auth/EmailAuthCandidates.js";
import { getPublicEmailAuthCandidatesUrl } from "@Front/Api/helpers/publicApiUrls";
import { makePublicHttpRequest } from "@Front/Api/helpers/publicHttpRequestHelpers";
import { mapThrownPublicApiError } from "@Front/Api/helpers/publicApiThrownErrorHelpers";
import { resolvePublicApiErrorMessage } from "@Front/Components/DesignSystem/helpers/resolvePublicApiErrorMessage";

export type {
	CustomerLoginCandidate as CustomerLoginCandidateDto,
	ThirdPartyLoginCandidate as ThirdPartyLoginCandidateDto,
	EmailAuthCandidatesSnapshot as EmailAuthCandidatesResponse,
} from "le-coffre-resources/dist/Auth/EmailAuthCandidates.js";

export async function postPublicEmailAuthCandidates(body: {
	email: string;
	folderUid?: string;
	officeUid?: string;
}): Promise<EmailAuthCandidatesSnapshot> {
	try {
		return await makePublicHttpRequest<EmailAuthCandidatesSnapshot>(getPublicEmailAuthCandidatesUrl(), "POST", body);
	} catch (e: unknown) {
		throw mapThrownPublicApiError(e, resolvePublicApiErrorMessage);
	}
}
